import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

export async function addFinancialLedgerEntry(appId, entry) {
  await addDoc(collection(db, 'artifacts', appId, 'public', 'data', 'financial_ledger'), {
    ...entry,
    createdAt: serverTimestamp(),
  });
}
